import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { alertActions } from '../../../_actions/alert.actions';
import { vaccineGroupService } from '../../../_services/vaccine-group.service';

export default function CreateGroup({ history }) {
  const dispatch = useDispatch();

  const [name, setName] = useState('');
  const [code, setCode] = useState(generateCode());
  const [loading, setLoading] = useState(false);

  function generateCode() {
    return (Math.random().toString(36).substring(2, 5) +
      Math.random().toString(36).substring(2, 5)).toUpperCase();
  }

  function handleSubmit() {
    if (name === '') {
      dispatch(alertActions.error('Please enter a name'));
    } else if (code === '') {
      dispatch(alertActions.error('Please enter a group code'));
    } else {
      setLoading(true);

      vaccineGroupService.create(name, code)
        .then(() => {
          setLoading(false);

          history.push('/vaccine/groups');

          dispatch(alertActions.success('Group Created!'));
        })
        .catch((error) => {
          setLoading(false);
          if (error.response.data.errors.code) {
            dispatch(alertActions.error('Group code is already taken. Please try a different code.'));
          } else {
            dispatch(alertActions.error('An error occurred. Please try again later.'));
          }
        });
    }
  }

  return <div className="mt-4">
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
        <li className="breadcrumb-item"><Link to="/vaccine/groups">Groups</Link></li>
        <li className="breadcrumb-item active" aria-current="page">Create</li>
      </ol>
    </nav>

    <div className="card axs-shadow">
      <div className="card-header">
        <h5>Create a Group</h5>
      </div>
      <div className="card-body">
        <form>
          <div className="form-group">
            <label>Group Name</label>
            <input onChange={e => setName(e.target.value)} value={name} type="text" className="form-control" />
          </div>

          <div className="form-group">
            <label>Group Code</label>
            <input onChange={e => setCode(e.target.value.trim())} value={code} type="text" className="form-control" />
          </div>

          <button onClick={handleSubmit} disabled={loading} type="button" className="btn btn-success">{loading ? 'Creating...' : 'Create Group'}</button>
        </form>
      </div>
    </div>
  </div>
}